import { EMPTY_STRING } from '../../../../../constants/common'
import { getRecipientRealId } from '../../../../../utils/email'
import { EMAIL_CREATION_FORM_FIELD_NAME_TEXT_OR_GOOGLE_TEMPLATE } from '../../EmailCreationForm.constants'
import { EmailSelectTemplateToTestOptionValue } from '../../EmailSelectTemplateToTestVariablesModal'

export function getTestVariablesReportItemId({ recipient, variable }) {
  return `${recipient || EMPTY_STRING}_${variable}`
}

export function getTestVariablesRecipientId(recipient) {
  return getRecipientRealId(recipient) ?? recipient.value ?? recipient.id
}

export function hasFailedTestVariablesReports(reports) {
  return reports.includes(null)
}

export function getTestVariablesTemplateReports({ docTemplates, reports }) {
  return docTemplates.map((docTemplate, index) => ({
    docTemplate,
    report: reports[index],
  }))
}

export function isTextTemplateSelected(textTemplate) {
  return Boolean(textTemplate?.id)
}

export function isGoogleTemplateTestSelected(values) {
  return (
    values[EMAIL_CREATION_FORM_FIELD_NAME_TEXT_OR_GOOGLE_TEMPLATE] ===
    EmailSelectTemplateToTestOptionValue.googleTemplate
  )
}
